import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/layout/header/Header";
import Footer from "../components/layout/footer/Footer";
import Button from "../components/ui/button/button";
import "../components/layout/error/not-found.css";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="page-shell page-shell--error">
      <Header />

      <main className="page-shell__content">
        <section className="not-found">
          <div className="not-found__glow" />

          <h1 className="not-found__code">
            404
          </h1>

          <p className="not-found__description">
            It seems you got a little bit lost.
            <br />
            The page you are looking for doesn't exist or has been moved.
          </p>

          <Button onClick={() => navigate("/")}>
            Go Back To Homepage
          </Button>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default NotFoundPage;